import { Action } from '../actions/action';
import { PlaceCardsBackToDeckAction } from '../actions/place-cards-back-to-deck-action';
import { Board } from '../board';
import { GameLogicDepth } from '../game-logic-depth';
import { GameLogicScore } from '../game-logic-score';
import { PointsType } from '../logic-types';
import { Command } from './command';

export class BackToDeckMoveCommand implements Command {
  private readonly deckShufflePoints: number = -100;

  public serializeToString(): string {
    return `backdeck`;
  }

  public execute(
    board: Board,
    gameLogicScore: GameLogicScore,
    gameLogicDepth: GameLogicDepth,
    actionList: Action[],
  ): boolean {
    const action = new PlaceCardsBackToDeckAction(board, gameLogicDepth);
    action.execute();
    actionList.push(action);

    gameLogicScore.addMove();
    gameLogicScore.addPoints(this.deckShufflePoints, PointsType.PlaceCardsBackToDeck, undefined);

    return true;
  }

  public static isCommand(command: Command): command is BackToDeckMoveCommand {
    return command instanceof BackToDeckMoveCommand;
  }
}
